import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Props } from './types';
import NoDataComponent from '../NoDataAvailable';

const DashboardTable = (props: Props) => (
  <Box height={'100%'} width={'100%'}>
    {(props.data || []).length === 0 ? (
      <NoDataComponent />
    ) : (
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {props.columns.map((column, index) => (
              <TableCell key={index}>{column.header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {props.columns.map((col, colIndex) => {
                const value = col.accessorKey === 'index' ? rowIndex + 1 : row[col.accessorKey];
                return (
                  <TableCell key={colIndex}>
                    {col.Cell
                      ? col.Cell(row)
                      : col.accessorFn
                      ? col.accessorFn(value)
                      : (value as string) ?? '-'}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )}
  </Box>
);

export default DashboardTable;
